import http from './ApiConfig';
import { Service } from './Service';
import TipoConsulta from '../models/agenda/TipoConsulta';

export class TipoConsultaService extends Service {
  constructor() {
    super('tipoConsulta');
  }

  public obterTodos(clinicaId: number) {
    return http.get(`${this._nomeControle}/listar-todos/${clinicaId}`, this.GetHeader());
  }

  public obterParaConsulta(clinicaId: number) {
    return http.get(`${this._nomeControle}/listar-para-consulta/${clinicaId}`, this.GetHeader());
  }

  public obterPorId(id: number) {
    return http.get(`${this._nomeControle}/${id}`, this.GetHeader());
  }

  public adicionar(tipoConsulta: TipoConsulta) {
    return http.post(`${this._nomeControle}`, tipoConsulta, this.GetHeader());
  }

  public atualizar(id: number, tipoConsulta: TipoConsulta) {
    return http.patch(`${this._nomeControle}/${id}`, tipoConsulta, this.GetHeader());
  }

  public remover(id: number) {
    return http.delete(`${this._nomeControle}/${id}`, this.GetHeader());
  }

  public obterTiposDisponiveis(clinicaId: number) {
    return http.get(`${this._nomeControle}/disponiveis-para-quadro/${clinicaId}`, this.GetHeader());
  }
}
